import { makeObservable, observable, toJS } from "mobx";
import { AnimationType, ParralaxEffect } from "../../../features/workspace/Site/helper";

export interface LanguageSwitcherElementProps {
  parentId: string | null

  id: string;
  x: number;
  y: number;
  width:  string | number;
  height:  string | number;
  position: 'absolute' | 'fixed',
  zIndex: number;
  opacity: number;
  bgColor: string | null;
  fontSize: number | string;
  fontWeight: number;
  letterSpacing: number
  lineHeight: number | string;
  textDecoration: string;


  typefaceId: string;
  animation: AnimationType
  parralax: ParralaxEffect | null
  name: string | null;
  rotate: number;
  borderRadius: number;
  borderWidth: number;
  borderColor: string | null;
  anchor: string | null

  hasCaret: boolean;
  hasIcon: boolean;
  textColor: string;
  caretColor: string;
  iconColor: string;
  caretSize: string;
  iconSize: string;
}

export default class LanguageSwitcherElement {
  @observable anchor: string | null
  @observable parentId: string | null

  @observable typefaceId: string

  @observable id: string;
  @observable x: number;
  @observable y: number;
  @observable width:  string | number;
  @observable height:  string | number;
  @observable position: 'absolute' | 'fixed';
  @observable zIndex: number;
  @observable opacity: number;
  @observable bgColor: string | null;
  @observable fontSize: number;
  @observable fontWeight: number;
  @observable letterSpacing: number;
  @observable lineHeight: number;
  @observable textDecoration: string;
  @observable textAlign: 'left' | 'center' | 'right';
  @observable animation: AnimationType

  @observable link: string | null;
  @observable name: string | null;
  @observable rotate: number;
  @observable parralax: ParralaxEffect | null

  @observable borderRadius: number;
  @observable borderWidth: number;
  @observable borderColor: string | null;

  @observable hasCaret: boolean;
  @observable hasIcon: boolean;
  @observable textColor: string;
  @observable caretColor: string;
  @observable iconColor: string;
  @observable caretSize: string;
  @observable iconSize: string;

  constructor(props: LanguageSwitcherElementProps) {
    Object.assign(this, props);
    makeObservable(this);
  }

  toJSON() {
    return toJS(this);
  }
}
